var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"flex items-center space-x-2 absolute right-0"},[(_vm.$slots.default[0].text)?_c('svg-icon',{staticClass:"icon",attrs:{"icon-class":"caution"}}):_vm._e(),_c('span',{staticClass:"errorSpan"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }